import _ from "lodash";
import React, { Component } from "react";
import {
  editBooth,
  showBoothEditor,
  updateBooth,
  addNewBooth,
} from "InteractiveMapAction";
import { connect } from "react-redux";
import Draggable, { DraggableCore } from "react-draggable";

class Booth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeDrags: 0,

      deltaPosition: {
        x: 0,
        y: 0,
      },
      controlledPosition: {
        x: this.props.booth.location_x,
        y: this.props.booth.location_y,
      },
      beenDragged: false,
    };
    this.onStart = this.onStart.bind(this);
    this.onStop = this.onStop.bind(this);
    this.handleDrag = this.handleDrag.bind(this);

    this.onLocationClick = this.onLocationClick.bind(this);
  }

  handleDrag(e, ui) {
    e.stopPropagation();
    const { x, y } = this.state.deltaPosition;
    this.setState({
      deltaPosition: {
        x: x + ui.deltaX,
        y: y + ui.deltaY,
      },
      controlledPosition: {
        x: ui.x,
        y: ui.y,
      },
    });
  }

  onStart() {
    this.setState({ activeDrags: ++this.state.activeDrags, beenDragged: true });
  }

  onStop() {
    this.setState({
      activeDrags: --this.state.activeDrags,
      beenDragged: false,
    });
    if (this.state.controlledPosition && this.state.controlledPosition.y) {
      var updatedBooth = {
        ...this.props.booth,
        location_x: this.state.controlledPosition.x,
        location_y: this.state.controlledPosition.y,
      };
      this.updateBooth(updatedBooth);
    }
  }

  onLocationClick(e) {
    // debugger;
    if (this.state.beenDragged) {
      return;
    }
    e.preventDefault();

    if (this.props.toAddNewBooth) {
      this.props.showBoothEditor(true);
    } else {
      this.props.editBooth(this.props.booth);
    }
  }

  updateBooth(booth) {
    //Check if booth created on server to update in server

    if (_.startsWith(booth.locationid, "booth")) {
      //Not stored in server, update locally
      this.props.addNewBooth(booth);
    } else {
      var boothToUpdate = { resource: [booth] };
      this.props.updateBooth(
        this.props.session,
        boothToUpdate,
        this.props.selectedMap.interactivemapid,
        () => {},
        () => {}
      );
    }
  }

  render() {
    var { booth } = this.props;
    const boothColor = booth.color;
    var boothContainerStyle = {
      border: "2px",
      borderColor: boothColor,
      borderStyle: "solid",
      display: "inline-block",
      width: "50px",
      height: "50px",
      cornerRadius: 2,
    };
    var boothStyle = {
      backgroundColor: boothColor,
      display: "inline-block",
      opacity: 0.5,
      width: "48px",
      height: "48px",
    };
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };

    return (
      <Draggable
        position={this.state.controlledPosition}
        defaultPosition={{
          x: this.props.booth.location_x,
          y: this.props.booth.location_y,
        }}
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <div style={boothContainerStyle} onClick={this.onLocationClick}>
          <div style={boothStyle} />
        </div>
      </Draggable>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    toAddNewBooth: state.addEditBooth.toAddNewBooth,
    selectedMap: state.selectediMap,
  };
}

export default connect(mapStateToProps, {
  editBooth,
  showBoothEditor,
  updateBooth,
  addNewBooth,
})(Booth);
